module.exports = __webpack_public_path__ + "static/media/WXRWYR1.8b04698f.png";